const defaultRange = (now, objs) => {
  if (!objs) {
    return null;
  }
  let minimumInternalValue = Number.MAX_SAFE_INTEGER;
  let minimumInternalObj = null;
  let minimumExternalValue = Number.MAX_SAFE_INTEGER;
  let minimumExternalObj = null;

  for (const obj of objs) {
    // Get the number of ms that startValidity is after the current time
    // Returns a negative number if startValidity is before now
    const msBeforeStart = window.moment
      .utc(obj.startValidity || obj.sv)
      .diff(now);

    // Check to see if the current time is before the start validity
    if (msBeforeStart > 0) {
      // How much before? Are we the closest to current time that we've been?
      if (msBeforeStart < minimumExternalValue) {
        minimumExternalValue = msBeforeStart;
        minimumExternalObj = obj;
      }
      continue;
    }

    // Get the number of ms that now is after the endValidity
    const msAfterEnd = now.diff(window.moment.utc(obj.endValidity || obj.ev));

    // Check to see if the current time is after the end validity
    if (msAfterEnd > 0) {
      if (msAfterEnd < minimumExternalValue) {
        minimumExternalValue = msAfterEnd;
        minimumExternalObj = obj;
      }
      continue;
    }

    // Get the smallest delta
    const delta = Math.abs(Math.max(msBeforeStart, msAfterEnd));

    // Is that delta smaller than or equal to the current smallest delta?
    // The reason that we accept "equal to" is for the hour rollover, when the previous obj is
    // valid until *RIGHT NOW* and the next obj is valid starting *RIGHT NOW*, we want the next obj
    if (delta <= minimumInternalValue) {
      minimumInternalValue = delta;
      minimumInternalObj = obj;
    }
  }
  // Prefer minimum internal object over minimum external object over the first item in the
  // passed-in array
  return minimumInternalObj
    ? minimumInternalObj
    : minimumExternalObj
    ? minimumExternalObj
    : objs[0];
};

export const defaultFrameList = defaultRange;
export const defaultFrame = defaultRange;

/**
 * Get the default image (most recent)
 *
 * Sort descending according to unix timestamp and take the first one
 *
 */
export const defaultImage = images => {
  let copy = Array.from(images);
  copy.sort(
    (a, b) =>
      window.moment.utc(b.created).valueOf() -
      window.moment.utc(a.created).valueOf()
  );
  return copy[0];
};
